import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { OfbizForm } from '@urbannex/ofbiz-forms';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { LookupService } from '../lookup.service';

@Component({
  selector: 'kve-lookup-form',
  templateUrl: './lookup-form.component.html',
  styleUrl: './lookup-form.component.scss'
})
export class LookupFormComponent implements OnInit, OnDestroy{
  
  @Input() ofbizForm:OfbizForm;
  @Input() title:string;
  viewMode:string = "collapsible";
  isLookup:boolean = true;

  selectedValueSubscription:Subscription;
  private destroy$ = new Subject<void>();

  @Output() setLookupSelectedValue = new EventEmitter();
  
  constructor(private lookupService:LookupService) { }

  setFormData(e){

  }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }
  ngOnInit(): void {
    this.selectedValueSubscription = this.lookupService.getSelectedRow()
      .pipe(takeUntil(this.destroy$))
      .subscribe(data => {
        console.log({TrackLookupSelectedValue:data});
        this.setLookupSelectedValue.emit(data);
      })
  }
}
